import React from 'react';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import TaxForm from './forms/TaxForm';
import { Tax } from '../../../app/models/Tax';

interface Props {
    fetching?: boolean;
    action: () => void;
    cancel: () => void;
    tax: Tax;
    setTax: (tax: Tax) => void;
    errorFields?: any;
}

const TaxFormContainer = ({
    fetching,
    action,
    cancel,
    tax,
    setTax,
    errorFields = null
}: Props) => {
    return (
        <>
            <div className="row">
                <div className="col-12">
                    <TaxForm
                        taxDataForm={tax}
                        setTaxDataForm={setTax}
                        errorFields={errorFields}
                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={cancel} locked={fetching} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={action} locked={fetching} />
                </div>
            </div>
        </>
    );
};

export default TaxFormContainer;
